module.exports = __webpack_public_path__ + "media/audio21.96cd5118.mp3";